import { render, staticRenderFns } from "./ResultImagePreview.vue?vue&type=template&id=2e2a824c&scoped=true&"
import script from "./ResultImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ResultImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ResultImagePreview.vue?vue&type=style&index=0&id=2e2a824c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a824c",
  null
  
)

export default component.exports